export default __webpack_public_path__ + "static/media/advanced-android.9afa2a20.png";